import {useState} from 'react'
import {SelectNoFormik, SelectNoFormikProps} from '../../../../../_gori/partials/widgets'
import {
  MESSAGE_TYPE,
  MessageContent,
  MessageItemCommonProps,
  MessageModel,
  MessageOption,
} from '../../definitions'
import {MessageItemWrapper} from './MessageItemWrapper'
import {useIntl} from 'react-intl'
import {useChatbotContext} from '../../context'

type MessageItemDropdownSelectProps = MessageItemCommonProps<{options: MessageOption[]}> &
  Omit<SelectNoFormikProps, 'options' | 'className'>

export const MessageItemDropdownSelect = ({
  hasUseIntl = false,
  placeholder,
  message,
  ...selectProps
}: MessageItemDropdownSelectProps) => {
  const defaultValue = message?.content?.options?.find((item) => item.selected)

  const {handleCreateMessage, disabledUserAction} = useChatbotContext()

  const [value, setValue] = useState(defaultValue)
  const intl = useIntl()

  const handleOnChange = (value) => {
    handleCreateMessage({
      type: MESSAGE_TYPE.DROPDOWN_SELECT,
      message: {...value, selected: true},
      currentMessageId: message.id,
    })
    setValue(value)
  }

  return (
    <MessageItemWrapper
      className='bg-primary-200 min-w-75'
      message={message as unknown as MessageModel<MessageContent>}
      wrapperClassName='d-flex w-100 justify-content-end'
    >
      <div className='mb-3 text-white'>{intl.formatMessage({id: 'SELECT_ONE'})}:</div>
      <SelectNoFormik
        disabled={disabledUserAction}
        hasUseIntl={hasUseIntl}
        placeholder={placeholder || intl.formatMessage({id: 'SELECT'})}
        {...selectProps}
        value={value}
        onChange={(value) => {
          handleOnChange(value)
        }}
        options={message?.content?.options || []}
      />
    </MessageItemWrapper>
  )
}
